// extracted by mini-css-extract-plugin
module.exports = {"expertise":"real-estate-expertise_expertise__Cvujf","expertise_title":"real-estate-expertise_expertise_title__CC8pH","expertise_text":"real-estate-expertise_expertise_text__9jeYX"};